var _ellipse, _path, _path2, _path3, _rect, _path4, _path5, _path6, _path7, _g, _g2, _g3, _path8, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_discover",
    xmlns: "http://www.w3.org/2000/svg",
    width: 82.351,
    height: 14.079,
    viewBox: "0 0 82.351 14.079",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_52",
    "data-name": "Ellipse 52",
    cx: 6.907,
    cy: 6.907,
    rx: 6.907,
    ry: 6.907,
    transform: "translate(36.792 0.133)",
    fill: "#ef9122"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M221.6,176.907a6.907,6.907,0,1,1,6.907,6.907",
    transform: "translate(-184.808 -169.867)",
    fill: "#f26e21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M234.4,171.992a6.856,6.856,0,0,1,9.7,9.7",
    transform: "translate(-195.483 -169.867)",
    fill: "#f44500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M3.719,172.4H0v13.017H3.719a7.2,7.2,0,0,0,4.649-1.461,6.568,6.568,0,0,0,2.391-5.047C10.759,175.056,7.969,172.4,3.719,172.4Zm3.055,9.829a5.105,5.105,0,0,1-3.453,1.063h-.8v-8.633h.664a4.508,4.508,0,0,1,3.453,1.063A4.243,4.243,0,0,1,8.1,178.908,3.97,3.97,0,0,1,6.774,182.229Z",
    transform: "translate(0 -171.868)",
    fill: "#595a5b"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "SVGCleanerId_0",
    width: 2.524,
    height: 13.017,
    transform: "translate(11.954 0.531)",
    fill: "#595a5b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M98.913,176.78c-1.594-.531-1.992-.93-1.992-1.594a1.681,1.681,0,0,1,1.86-1.461,2.57,2.57,0,0,1,2.125,1.063l1.328-1.727a5.787,5.787,0,0,0-3.852-1.461,3.9,3.9,0,0,0-4.118,3.719c0,1.86.8,2.656,3.188,3.586a5.165,5.165,0,0,1,1.727.8,1.461,1.461,0,0,1,.8,1.328,1.852,1.852,0,0,1-1.992,1.86,3.1,3.1,0,0,1-2.789-1.727L93.6,182.757a5.209,5.209,0,0,0,4.516,2.524,4.189,4.189,0,0,0,4.516-4.25C102.632,178.772,101.835,177.843,98.913,176.78Z",
    transform: "translate(-78.06 -171.201)",
    fill: "#595a5b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M152.8,176.24a6.749,6.749,0,0,0,6.907,6.774,7.513,7.513,0,0,0,3.188-.8v-3.055a4.13,4.13,0,0,1-3.055,1.461,4.292,4.292,0,0,1-4.383-4.516,4.343,4.343,0,0,1,4.25-4.516,4.187,4.187,0,0,1,3.188,1.461V170a6.674,6.674,0,0,0-3.188-.8A7.341,7.341,0,0,0,152.8,176.24Z",
    transform: "translate(-127.431 -169.2)",
    fill: "#3b3d3f"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M307.843,181.166l-3.453-8.766H301.6l5.446,13.415h1.461l5.711-13.415h-2.789Z",
    transform: "translate(-251.525 -171.868)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M384,185.417h7.305v-2.125h-4.649v-3.586h4.516v-2.258h-4.516v-2.789h4.649V172.4H384Z",
    transform: "translate(-320.244 -171.868)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125",
    transform: "translate(0 0.531)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M443.846,179.971a3.5,3.5,0,0,0,3.055-3.719c0-2.391-1.727-3.852-4.649-3.852H438.4v13.017h2.524v-5.18h.4l3.586,5.18h3.055Zm-2.125-1.594h-.8v-3.985h.8c1.594,0,2.524.664,2.524,1.992S443.315,178.377,441.721,178.377Z",
    transform: "translate(-365.612 -172.4)",
    fill: "#595a5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M3.719,172.4H0v13.017H3.719a7.2,7.2,0,0,0,4.649-1.461,6.568,6.568,0,0,0,2.391-5.047C10.759,175.056,7.969,172.4,3.719,172.4Zm3.055,9.829a5.105,5.105,0,0,1-3.453,1.063h-.8v-8.633h.664a4.508,4.508,0,0,1,3.453,1.063A4.243,4.243,0,0,1,8.1,178.908,3.97,3.97,0,0,1,6.774,182.229Z",
    transform: "translate(0 -172.4)",
    fill: "#595a5b"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_126",
    "data-name": "Group 126",
    transform: "translate(11.954 0.531)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGCleanerId_0_1_",
    width: 2.524,
    height: 13.017,
    transform: "translate(0 0)",
    fill: "#595a5b"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_127",
    "data-name": "Group 127",
    transform: "translate(15.54 0.398)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M98.913,176.78c-1.594-.531-1.992-.93-1.992-1.594a1.681,1.681,0,0,1,1.86-1.461,2.57,2.57,0,0,1,2.125,1.063l1.328-1.727a5.787,5.787,0,0,0-3.852-1.461,3.9,3.9,0,0,0-4.118,3.719c0,1.86.8,2.656,3.188,3.586a5.165,5.165,0,0,1,1.727.8,1.461,1.461,0,0,1,.8,1.328,1.852,1.852,0,0,1-1.992,1.86,3.1,3.1,0,0,1-2.789-1.727L93.6,182.757a5.209,5.209,0,0,0,4.516,2.524,4.189,4.189,0,0,0,4.516-4.25C102.632,178.772,101.835,177.843,98.913,176.78Z",
    transform: "translate(-93.6 -171.6)",
    fill: "#595a5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M160.486,192.354a7.513,7.513,0,0,0,3.188-.8V188.5a4.13,4.13,0,0,1-3.055,1.461,4.292,4.292,0,0,1-4.383-4.516,4.967,4.967,0,0,1,1.328-3.321l-1.727-1.727a6.911,6.911,0,0,0-2.258,5.047A6.625,6.625,0,0,0,160.486,192.354Z",
    transform: "translate(-143.617 -178.939)",
    fill: "#595a5b"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M443.846,179.971a3.5,3.5,0,0,0,3.055-3.719c0-2.391-1.727-3.852-4.649-3.852H438.4v13.017h2.524v-5.18h.4l3.586,5.18h3.055Zm-2.125-1.594h-.8v-3.985h.8c1.594,0,2.524.664,2.524,1.992S443.315,178.377,441.721,178.377Z",
    transform: "translate(-365.612 -171.868)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_129",
    "data-name": "Group 129",
    transform: "translate(50.075 0.531)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M389.047,212.647h-2.391v-2.391L384,207.6v7.172h7.173Z",
    transform: "translate(-370.319 -201.756)",
    fill: "#3b3d3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M310.765,173.728l-2.922,7.438-3.453-8.766H301.6l5.446,13.415h1.461l4.25-10.095Z",
    transform: "translate(-301.6 -172.4)",
    fill: "#3b3d3f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.53be6c96174bace317601e1c2685489b.svg";
export { ForwardRef as ReactComponent };